import { Root } from './style';

interface IconLargeCicleProps {
  children: React.ReactNode;
}

export default function IconLargeCicle({ children }: IconLargeCicleProps) {
  return <Root>{children}</Root>;
}
